import {
	MediaCommands,
	useMediaCommands,
} from 'features/media-streaming/use-media-commands'
import useYouTubeStreamingApi from './youtube-streaming-api'

/** The film's commands, for its player and the console's remote alike. */
export const useYouTubeCommands = (): MediaCommands =>
	useMediaCommands(useYouTubeStreamingApi())

export default useYouTubeCommands
